export const ROLES={
   management: 1,
   manager:2,
   corporateAdmin: 3,
   supervisor:4
}